/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import FormCreator from '../../components/FinalForms/FormCreator';
import { MainSkillCategoryDataFields } from './MainCategoryList.Data';
import { onResetForm } from '../../utils/FormFields/ResetForm/handleResetForm';
import Buttons from '../../components/ui/button/Buttons';
import ToastService from '../../services/toastService/ToastService';
import { useAddEditMainSkillMutation, useLazyGetMainSkillByMainSkillIdQuery } from '../../app/services/mainSkillCategoriesAPI';
import { setDropDownOptionField } from '../../utils/FormFields/FieldsSetting/SetFieldSetting';
import { useLazyGetAllSkillCategoriesQuery } from '../../app/services/skillCategoriesAPI';
import { hasFunctionalPermission } from '../../utils/authorizeNavigation/authorizeNavigation';
import { securityKey } from '../../data/SecurityKey';


const AddMainSkillCategory = (props) => {
  const ref = useRef();
  const [skillCategoriesData, setSkillCategoriesData] = useState(MainSkillCategoryDataFields);
  const mainSkillId = props.initData?.mainSkillId;
  const [getAllSkillCategories, { isFetching: isGetAllSkillCategoriesFetching, isSuccess: isGetAllSkillCategoriesSuccess, data: isGetAllSkillCategoriesData }] = useLazyGetAllSkillCategoriesQuery();
  const [isButtonDisable, setIsButtonDisable] = useState(false);

  const hasAddPermission = hasFunctionalPermission(securityKey.ADDMAINSKILL);
  const hasEditPermission = hasFunctionalPermission(securityKey.EDITMAINSKILL);

  const { formSetting } = MainSkillCategoryDataFields;

  const [addEditSkillCategories, { isLoading: isAddEditSkillCategoriesLoading, isSuccess: isAddEditSkillCategoriesSuccess, data: AddEditSkillCategoriesData, }] = useAddEditMainSkillMutation();
  const [getSkillCategoriesById, { isFetching: isGetSkillCategoriesByIdFetching, isSuccess: isGetSkillCategoriesByIdSuccess, data: isGetSkillCategoriesByIdData, }] = useLazyGetMainSkillByMainSkillIdQuery();


  useEffect(() => {
    if (!props.isEdit) {
        if (hasAddPermission && hasAddPermission.hasAccess === true) {
            formSetting.isViewOnly = false;
            setIsButtonDisable(false);
        }
    }
    else if (props.isEdit) {
        if (hasEditPermission.isViewOnly === true) {
            formSetting.isViewOnly = true;
            setIsButtonDisable(true)
        }
    }
}, [hasAddPermission, hasEditPermission, formSetting.isViewOnly]);


  useEffect(() => {
    getAllSkillCategories();
  }, []);

  useEffect(() => {
    if (mainSkillId && props.isEdit) {
      getSkillCategoriesById(mainSkillId);
    }
  }, [mainSkillId, props.isEdit]);

  useEffect(() => {

    if (!isGetAllSkillCategoriesFetching && isGetAllSkillCategoriesSuccess && isGetAllSkillCategoriesData) {
      setDropDownOptionField(isGetAllSkillCategoriesData, "skillCategoriesId", "skillCategoriesName", skillCategoriesData, "skillCategoriesId");
    }
  }, [isGetAllSkillCategoriesFetching, isGetAllSkillCategoriesSuccess, isGetAllSkillCategoriesData, skillCategoriesData])

  useEffect(() => {

    if (!isGetSkillCategoriesByIdFetching && isGetSkillCategoriesByIdSuccess && isGetSkillCategoriesByIdData) {
      if (isGetSkillCategoriesByIdData) {
        let formData = { ...skillCategoriesData };
        formData.initialState = {
          mainSkillId: isGetSkillCategoriesByIdData.mainSkillId,
          mainSkillName: isGetSkillCategoriesByIdData.mainSkillName,
          skillCategoriesId: isGetSkillCategoriesByIdData.skillCategoriesId,
          description: isGetSkillCategoriesByIdData.description
        };
        setSkillCategoriesData(formData);
      }
    }
  }, [isGetSkillCategoriesByIdFetching, isGetSkillCategoriesByIdSuccess, isGetSkillCategoriesByIdData,]);

  useEffect(() => {
    if (isAddEditSkillCategoriesSuccess && AddEditSkillCategoriesData) {
      if (AddEditSkillCategoriesData.errorMessage.includes("exists")) {
        ToastService.warning(AddEditSkillCategoriesData.errorMessage);
        return;
      }
      props.onSuccess();
      onResetData();
      ToastService.success(AddEditSkillCategoriesData.errorMessage);
    }
  }, [isAddEditSkillCategoriesSuccess, AddEditSkillCategoriesData]);

  useEffect(() => {
    if (props.isModelOpen && !props.isEdit) {
      let formData = { ...MainSkillCategoryDataFields };
      onResetForm(formData, setSkillCategoriesData, null);
    }
  }, [props.isModelOpen]);

  const onResetData = () => {
    let formData = { ...MainSkillCategoryDataFields };
    onResetForm(formData, setSkillCategoriesData, null);
    props.onClose();
  };

  const handleAdd = () => {
    const formData = ref.current?.getFormData();
    if (formData) {
      const requestData = {
        mainSkillId: mainSkillId || 0,
        mainSkillName: formData.mainSkillName,
        skillCategoriesId: formData.skillCategoriesId && typeof formData.skillCategoriesId === "object"
          ? formData.skillCategoriesId.value
          : formData.skillCategoriesId,
        description: formData.description
      };
      addEditSkillCategories(requestData);
    }
  };

  return (
    <div className="skill-add-sec">
      <form>
        <div className="row mt-2">
          <FormCreator
            config={skillCategoriesData}
            ref={ref}
            {...skillCategoriesData}
          />
        </div>
      </form>
      <div className="row">
        <div className="col-12">
          <div className="form-btn d-flex align-items-center justify-content-end mb-2">
            <Buttons
              buttonTypeClassName="dark-btn mr-5"
              onClick={onResetData}
              buttonText="Cancel"
            />
            <Buttons
              buttonTypeClassName="theme-btn"
              isDisable = {isButtonDisable}
              onClick={handleAdd}
              buttonText={props.isEdit ? "Update" : "Save"}
              isLoading={isAddEditSkillCategoriesLoading}
            />
          </div>
        </div>
      </div>
    </div>
  )
};

export default AddMainSkillCategory
